import React, { forwardRef } from 'react';

interface PowerOffProps {
  classes?: string;
  style?: React.CSSProperties;
  forwardRef?: React.RefObject<HTMLElement>;
}

export const PowerOff = forwardRef<HTMLElement, PowerOffProps>(({ classes, style = {}, forwardRef: _ }, ref) => {
  return (
    <i ref={ref} className={`fa-solid fa-power-off ${classes}`} style={style}></i>
  );
});

PowerOff.displayName = 'PowerOff';
